import React from 'react';
import {IProps} from './types';
import ComboBox from '@components/ComboBox';
import * as S from './styles';

const TemplateStatus:React.FC<IProps> = (props) => {

  const statusOptions = ["Unpublished", "Published", "Disabled"];
  const statusOptionsCapitalized = [...statusOptions].map(o => o.toUpperCase());
  const [value, setValue] = React.useState("");

  const handleSelectOption = (id:string, value:string) => {
    const statusIndex = statusOptions.findIndex((item: string) => (item === value));
    if (statusIndex >= 0) {
      setValue(statusOptions[statusIndex]);
      props.setFiles(props.files.map(file => {return {
        ...file,
        templateStatus: statusOptionsCapitalized[statusIndex],
      }}));
    }
  }

  const capitalizeFirstLetter = (value: string) => {
    var newValue = value;
    newValue = newValue.toLocaleLowerCase().replace(/^./, newValue[0].toUpperCase());
    return newValue;
  }

  return (
    <S.Root>
      <S.Title>Status</S.Title>
      <ComboBox 
        id="status"
        placeholder="Status"
        options={statusOptions}
        required={false}
        disabled={false}
        position={"bottom"}
        chooseOption={handleSelectOption}
        value={props.files.length < 2 ? props.files[0]?.templateStatus ? capitalizeFirstLetter(props.files[0].templateStatus) : "" : value}
      />
    </S.Root >
  );
}

export default TemplateStatus;